module.exports = __webpack_public_path__ + "img/amber.9de5263e.svg";